import script from "./BaseTableHeaderSlider.vue?vue&type=script&setup=true&lang=ts"
export * from "./BaseTableHeaderSlider.vue?vue&type=script&setup=true&lang=ts"

import "./BaseTableHeaderSlider.vue?vue&type=style&index=0&id=2997f82f&lang=sass&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-2997f82f"]])

export default __exports__
import QSeparator from 'quasar/src/components/separator/QSeparator.js';
import QCarousel from 'quasar/src/components/carousel/QCarousel.js';
import qInstall from "../../../../node_modules/@quasar/app-webpack/lib/webpack/runtime.auto-import.js";
qInstall(script, 'components', {QSeparator,QCarousel});
